import Clarity from '@microsoft/clarity';
var CLARITY_PROJECT_ID = 'uc5v9c5qr3';
var clarityInitialized = false;
/**
 * Inicializa Microsoft Clarity (garante inicialização única)
 */
export var initClarity = function () {
    if (typeof window === 'undefined')
        return;
    if (clarityInitialized)
        return;
    try {
        Clarity.init(CLARITY_PROJECT_ID);
        clarityInitialized = true;
        // console.log('[Clarity] Inicializado com sucesso via NPM');
    }
    catch (error) {
        console.error('[Clarity] Erro ao inicializar:', error);
    }
};
/**
 * Rastreia mudança de página
 */
export var trackPageView = function (path) {
    try {
        if (!clarityInitialized)
            return;
        Clarity.setTag('page', path);
        // console.log('[Clarity] Page view:', path);
    }
    catch (error) {
        console.error('[Clarity] Erro ao rastrear página:', error);
    }
};
/**
 * Identifica usuário (enviando apenas primeiros 10 chars do email + ID)
 */
export var identifyUser = function (userId, email) {
    try {
        if (!clarityInitialized)
            return;
        var emailPrefix = email ? email.substring(0, 10) : 'unknown';
        Clarity.identify(userId, undefined, undefined, emailPrefix);
        // console.log('[Clarity] User identified:', userId, `(email: ${emailPrefix}...)`);
    }
    catch (error) {
        console.error('[Clarity] Erro ao identificar usuário:', error);
    }
};
/**
 * Rastreia evento customizado
 */
export var trackEvent = function (eventName) {
    try {
        if (!clarityInitialized)
            return;
        Clarity.event(eventName);
        // console.log('[Clarity] Event tracked:', eventName);
    }
    catch (error) {
        console.error('[Clarity] Erro ao rastrear evento:', error);
    }
};
/**
 * Para/pausa a captura do Clarity (útil para LGPD/GDPR)
 */
export var pauseClarity = function () {
    try {
        if (!clarityInitialized)
            return;
        Clarity.consent(false);
        // console.log('[Clarity] Captura pausada (consent revoked)');
    }
    catch (error) {
        console.error('[Clarity] Erro ao pausar:', error);
    }
};
/**
 * Retoma a captura do Clarity
 */
export var resumeClarity = function () {
    try {
        if (!clarityInitialized)
            return;
        Clarity.consent(true);
        // console.log('[Clarity] Captura retomada (consent granted)');
    }
    catch (error) {
        console.error('[Clarity] Erro ao retomar:', error);
    }
};
/**
 * Marca sessão como importante (upgrade)
 */
export var upgradeSession = function (reason) {
    try {
        if (!clarityInitialized)
            return;
        Clarity.upgrade(reason);
        // console.log('[Clarity] Sessão marcada como importante:', reason);
    }
    catch (error) {
        console.error('[Clarity] Erro ao fazer upgrade:', error);
    }
};
